import clsx from "clsx";

interface SkeletonProps {
  className?: string;
}

/**
 * Solid block placeholder with the global pulse animation. Used while data is
 * loading so layouts don't jump - much friendlier than a "Loading..." text.
 */
export function Skeleton({ className }: SkeletonProps): JSX.Element {
  return <div className={clsx("skeleton", className)} />;
}

interface SkeletonTilesProps {
  count?: number;
}

export function SkeletonTiles({ count = 4 }: SkeletonTilesProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="kpi-tile kpi-tile-disabled">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="mt-3 h-8 w-24" />
          <Skeleton className="mt-2 h-3 w-16" />
        </div>
      ))}
    </div>
  );
}
